// Types
import type { SxProps, Theme } from '@mui/material/styles'

// The light gray used for hover states across the site
export const HOVER_BG = '#f5f5f7'

// Close delay after the mouse leaves, so moving from the button to the panel does not close the menu
export const CLOSE_DELAY = 150

// Header menu button (Solutions, Resources, ...): same style as the other header links, gray on hover
export const triggerSx = (open: boolean): SxProps<Theme> => ({
	color: 'text.primary',
	fontSize: 15,
	fontWeight: 600,
	textTransform: 'inherit',
	px: 1.5,
	py: 0.75,
	borderRadius: 2,
	transition: 'background-color .2s, color .2s',
	'& .MuiButton-endIcon': { mx: 0.5 },
	...(open && { bgcolor: HOVER_BG, color: 'grey.600' }),
	'&:hover': { bgcolor: HOVER_BG, color: 'grey.600' }
})

// Blurred backdrop under the app bar while a menu is open
export const backdropSx = (top: number): SxProps<Theme> => ({
	position: 'fixed',
	inset: 0,
	top: `${top}px`,
	zIndex: t => t.zIndex.appBar - 2,
	bgcolor: 'rgba(23, 23, 23, 0.12)',
	backdropFilter: 'blur(8px)',
	WebkitBackdropFilter: 'blur(8px)'
})

// Link inside a menu panel; hovering one fades the other items in its group (dimSiblingsSx on the parent)
export const menuItemSx: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'flex-start',
	gap: 1.25,
	mx: -1,
	px: 1,
	py: 0.875,
	borderRadius: 1.5,
	color: 'text.primary',
	textDecoration: 'none',
	transition: 'background-color .15s, opacity .15s',
	'& .MuiSvgIcon-root': { fontSize: 20, mt: 0.125, flexShrink: 0 },
	'&:hover': { bgcolor: HOVER_BG }
}

export const dimSiblingsSx: SxProps<Theme> = { '&:has(.mega-item:hover) .mega-item:not(:hover)': { opacity: 0.45 } }
